import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-50">
      <div className="shell py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <div className="leading-none">
                <p className="font-heading text-[17px] font-extrabold text-foreground-950">华丽的外出</p>
                <p className="font-label mt-1 text-[10px] uppercase tracking-[0.22em] text-foreground-400">
                  Film Journal
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个专注于剧情、演员与剧集细节的影视内容站。我们把每部作品讲清楚，
              也把幕后那些值得被记住的瞬间留下来。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="mailto:hello@hualidewaichu.com"
                aria-label="发送邮件给我们"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-mail-line text-base" />
              </a>
              <Link
                to="/contact"
                aria-label="通过联系页面找到我们的社群"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-wechat-line text-base" />
              </Link>
              <Link
                to="/news"
                aria-label="查看影视动态"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-newspaper-line text-base" />
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
              内容分类
            </h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORIES.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category/${category.key}`}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {category.label}专区
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
              关于
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/news" className="text-sm text-foreground-700 transition-colors hover:text-primary-700">
                  影视动态
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground-700 transition-colors hover:text-primary-700">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-700 transition-colors hover:text-primary-700">
                  全部作品
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
              联系
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-foreground-400" />
                <span className="break-all">hello@hualidewaichu.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-foreground-400" />
                <span>工作日 10:00 - 19:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-foreground-400" />
                <span>上海市静安区影像街 27 号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 华丽的外出 · 本站内容为虚构示例，仅用于展示。
          </p>
          <p className="text-xs text-foreground-500">
            剧照与海报均为示意图 · 播放与下载功能仅为演示
          </p>
        </div>
      </div>
    </footer>
  );
}